import type { Command } from "../../types";
import type { ShapeManager } from "../ShapeManager";
import type { IShape, ShapeTransform } from "../shapes/interfaces/IShape";

export class ResizeShape implements Command {
    public shapeManager: ShapeManager;
    private shape: IShape;
    private oldTransform: ShapeTransform;
    private newTransform: ShapeTransform;

    constructor(shapeManager: ShapeManager, shape: IShape, oldTransform: ShapeTransform, newTransform: ShapeTransform) {
        this.shapeManager = shapeManager;
        this.shape = shape;
        this.oldTransform = oldTransform;
        this.newTransform = newTransform;
    }

    execute(): void {
        this.shape.setTransform(this.newTransform);
    }

    undo(): void {
        this.shape.setTransform(this.oldTransform);
    }
}
